import React, { useState, useEffect } from "react";
import LOGO_SQUARE from "../media/imgs/0_logo_square.png";

function PlainLoading({ visible = true, duration = 450, text = "Loading" }) {
    const [exiting, setExiting] = useState(false);
    const [mounted, setMounted] = useState(true);

    useEffect(() => {
        if (!visible) {
            setExiting(true);
            const t = setTimeout(() => setMounted(false), duration);
            return () => clearTimeout(t);
        }
    }, [visible, duration]);

    if (!mounted) return null;

    return (
        <>
            <style>{`
                @keyframes plain-loading-go-out {
                    0%   {  opacity: 1; }
                    100% {  opacity: 0; }
                }
            `}</style>
            <div
                style={{
                    position: "fixed",
                    inset: 0,
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#FCFBF7",
                    animation: exiting
                        ? `plain-loading-go-out ${duration}ms cubic-bezier(0.4, 0, 0.2, 1) forwards`
                        : "none",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 8,
                    }}
                >
                    <img
                        src={LOGO_SQUARE}
                        alt="Loading logo"
                        style={{
                            width: 48,
                            height: 48,
                            objectFit: "contain",
                        }}
                    />
                    <span
                        style={{
                            fontSize: 12,
                            letterSpacing: 1,
                            fontWeight: 600,
                            color: "#333",
                            textTransform: "uppercase",
                            fontFamily: "monospace",
                        }}
                    >
                        {text}
                    </span>
                </div>
            </div>
        </>
    );
}

export default PlainLoading;
